<template>
   <div class="businessSystem">
       <router-view></router-view>
   </div>
</template>

<script>
    export default {
        name: "businessSystemImport"
    }
</script>

<style scoped>

</style>